var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "FE039D05-0801-4BEF-896D-48D9A5ED9CE4")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-all-2020",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CustomerPage_Account_open_V1",
    transform: "translate(-220.000000, -348.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(221.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "0 14 20 14 20 0 0 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "3.0737 2.6387 10.0527 8.0917 16.9267 2.6387"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.1279,
    y1: 6.834,
    x2: 3.0739,
    y2: 11.361,
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.0586,
    y1: 6.834,
    x2: 16.9266,
    y2: 11.361,
    id: "Stroke-5"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email.c3833ee4.svg";
export { ForwardRef as ReactComponent };